import * as React from 'react';
const SvgError = () =>
  /* @__PURE__ */ React.createElement(
    'svg',
    { width: 18, height: 18, fill: 'none' },
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M5.496 1.102a.56.56 0 0 1 .398-.165h6.212c.15 0 .293.06.398.165l4.394 4.394a.56.56 0 0 1 .165.398v6.212c0 .15-.06.293-.165.398l-4.394 4.394a.56.56 0 0 1-.398.165H5.894a.56.56 0 0 1-.398-.165l-4.394-4.394a.56.56 0 0 1-.165-.398V5.894c0-.15.06-.293.165-.398zm.63.96L2.063 6.128v5.746l4.065 4.065h5.746l4.065-4.065V6.127l-4.065-4.064z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M9.008 5.063a.966.966 0 0 1 .953 1.066l-.37 3.556a.594.594 0 0 1-1.182 0L8.04 6.129a.966.966 0 0 1 .968-1.066',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      d: 'M9 13.09a.682.682 0 1 0 0-1.363.682.682 0 0 0 0 1.364',
    }),
  );
export default SvgError;
